module.exports = __webpack_public_path__ + "img/scan-hanging.899bed93.svg";